import AuthService from "../services/AuthService";
import Swal from "sweetalert2";
import axios from "axios";
import {ERRORS_CODE} from "../const/error_code";

export function initializeRouter(router) {
    router.beforeEach((to, from, next) => {
        const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
        const loggedIn = AuthService.getUserCurrentLogin();
        if(requiresAuth && !loggedIn) {
            next({name: 'login'});
        } else if(to.path === '/login' && loggedIn) {
            next({ name: 'dashboard' });
        } else if(to.path === '/logout'){
            AuthService.removeToken();
            next({name: 'login'});
        } else {
            next();
        }
    });
    let isAlreadyFetchingAccessToken = false;
    let subscribers = [];
    function onAccessTokenFetched(access_token) {
        subscribers = subscribers.filter(callback => callback(access_token));
    }

    function addSubscriber(callback) {
        subscribers.push(callback);
    }

    axios.interceptors.response.use(response => response, (error) => {
        const originalRequest = error.config
        if (error.response.data.code === ERRORS_CODE.TOKEN_INVALID) {
            if (!isAlreadyFetchingAccessToken) { 
                isAlreadyFetchingAccessToken = true
                const refreshToken = AuthService.getRefreshToken();
                if (refreshToken) {
                    AuthService.refreshAccessToken(refreshToken).then((response) => {
                        AuthService.saveToken(JSON.stringify(response.data.data.token));
                        isAlreadyFetchingAccessToken = false;
                        onAccessTokenFetched(response.data.data.token);
                    });
                } else {
                    AuthService.removeToken();
                    return router.go({name: 'login'});
                }
            }
            const retryOriginalRequest = new Promise((resolve) => {
                addSubscriber(token => {
                    originalRequest.headers.Authorization = 'Bearer ' + token.access_token;
                    resolve(axios(originalRequest))
                })
            })
            return retryOriginalRequest
        } else if(error.response.status === 401) {
            AuthService.removeToken();
            return router.go({name: 'login'});
        } else {
            return Promise.reject(error);
        }
    });
}
export function alertResponseError(error) {
    return Swal.fire({
        title: 'Error!',
        text: `${error}`,
        icon: 'error',
        showCloseButton: true
    });
}

export function alertResponseSuccess(message) {
    return Swal.fire({
        title: '',
        text: `${message}`,
        icon: 'success',
    });
}
